<template>
  <div class="graficoalmacen">
    <div class="panel panel-flat">
      <div class="panel-body" style="text-align: center;">
        <span style="font-weight: 700; font-size: 16px; font-family: arial;">Almacén</span>
        <!-- SELECT -->
        <div class="row">
          <div class="col-lg-1">
            <span style="font-size: 16px; font-family: arial;" for="selectAlmacen">Almacén:</span>
          </div>
          <div class="col-lg-3">
            <select
              id="selectAlmacen"
              class="form-control form-control-sm"
              style="max-width: 300px;"
              ref="ialmacen"
              v-model="almacenid"
              @change="almacenChange()"
            >
              <option value="0">Todos</option>
              <option
                v-for="almacen in almacenes"
                :key="Number(Object.keys(almacen))"
                :value="Number(Object.keys(almacen))"
              >{{ String(Object.values(almacen)) }}</option>
            </select>
          </div>
        </div>
        <br />
        <!-- /SELECT -->
        <div class="row">
          <div class="col-lg-3">
            <div class="panel panel-flat" style="text-align: center;">
              <div class="panel-body">
                <h1>Articulos Stock total</h1>
                <h3>{{ totalStock }}</h3>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="panel panel-flat" style="text-align: center;">
              <div class="panel-body">
                <h1>Top Stock Articulo</h1>
                <h6>{{ toparticulo.nombre }}</h6>
                <span>{{ toparticulo.total }}</span>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="panel panel-flat" style="text-align: center;">
              <div class="panel-body">
                <h1>Top Familia</h1>
                <h6>{{ topfamilia.nombre }}</h6>
                <span>{{ topfamilia.total }}</span>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="panel panel-flat" style="text-align: center;">
              <div class="panel-body">
                <h1>Top Subfamilia</h1>
                <h6>{{ topsubfamilia.nombre }}</h6>
                <span>{{ topsubfamilia.total }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">
            <!-- Stock por familia -->
            <JqxLoader
              ref="jqxLoaderd1"
              :imagePosition="'top'"
              :width="100"
              :height="60"
              :theme="'custom'"
              :text="'Cargando...'"
            ></JqxLoader>
            <JqxChart
              style="width: 100%; height: 180px"
              ref="donut1"
              :title="'Stock por familia'"
              :description="''"
              :showLegend="false"
              :enableAnimations="true"
              :padding="padding"
              :titlePadding="titlePadding"
              :source="dataD1"
              :showToolTips="true"
              :seriesGroups="seriesGroupsDs"
              :colorScheme="'scheme01'"
              :backgroundColor="'#FAFAFA'"
              :showBorderLine="true"
            ></JqxChart>
            <!-- /Stock por familia -->
            <br />
            <br />
            <!-- Stock por subfamilia -->
            <JqxLoader
              ref="jqxLoaderd2"
              :imagePosition="'top'"
              :width="100"
              :height="60"
              :theme="'custom'"
              :text="'Cargando...'"
            ></JqxLoader>
            <JqxChart
              style="width: 100%; height: 180px"
              ref="donut2"
              :title="'Stock por subfamilia'"
              :description="''"
              :showLegend="false"
              :enableAnimations="true"
              :padding="padding"
              :titlePadding="titlePadding"
              :source="dataD2"
              :showToolTips="true"
              :seriesGroups="seriesGroupsDs"
              :colorScheme="'scheme01'"
              :backgroundColor="'#FAFAFA'"
              :showBorderLine="true"
            ></JqxChart>
            <!-- /Stock por subfamilia -->
          </div>
          <!-- Top 10 Articulos por almacen -->
          <div class="col-lg-9">
            <JqxLoader
              ref="jqxLoadertop10"
              :imagePosition="'top'"
              :width="100"
              :height="60"
              :theme="'custom'"
              :text="'Cargando...'"
            ></JqxLoader>
            <JqxChart
              style="width: 100%; height: 400px"
              ref="barrastop10"
              :title="'Top 10 Articulos'"
              :description="''"
              :enableAnimations="true"
              :showLegend="true"
              :padding="padding"
              :titlePadding="titlePadding"
              :source=" dataTop10"
              :xAxis=" xAxisTop10"
              :valueAxis=" valueAxisTop10"
              :seriesGroups=" seriesGroupsTop10"
              :colorScheme="'scheme01'"
            ></JqxChart>
          </div>
          <!-- /Top 10 Articulos por almacen -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import JqxChart from "jqwidgets-scripts/jqwidgets-vue/vue_jqxchart.vue";
import JqxLoader from "jqwidgets-scripts/jqwidgets-vue/vue_jqxloader.vue";
import { Util } from "@/api/Util";
import { BiApiService } from "@/api/BiApiService";

const util = new Util();
const biApiService = new BiApiService();
var numeral = require("numeral");
require("numeral/locales/es");

export default {
  components: {
    JqxChart,
    JqxLoader
  },
  data() {
    return {
      lang: this.$store.getters.lang,
      almacenid: null,
      almacenes: [],
      window: {
        width: 0,
        height: 0
      },
      // Donuts
      dataD1: [],
      dataD2: [],
      dataD3: [],
      dataD4: [],
      seriesGroupsDs: [
        {
          type: "donut",
          useGradient: false,
          useGradientColors: false,
          series: [
            {
              showLabels: false,
              enableSelection: true,
              displayText: "text",
              dataField: "value",
              labelRadius: 120,
              initialAngle: 90,
              radius: 60,
              innerRadius: 50,
              centerOffset: 0
            }
          ]
        }
      ],
      padding: { left: 5, top: 5, right: 5, bottom: 5 },
      titlePadding: { left: 5, top: 5, right: 5, bottom: 5 },
      // /Donuts
      //Stock por articulo
      // Barras horizontales
      dataTop10: [],
      valueAxisTop10: {
        flip: true,
        labels: {
          visible: true,
          formatFunction: value => {
            if (value === 0) {
              return String(0);
            } else if (value < 1000000) {
              return String(parseInt(value) / 1000 + "K");
            } else {
              return String(parseInt(value) / 1000000 + "M");
            }
          }
        }
      },
      xAxisTop10: {
        visible: false,
        dataField: "articulo",
        displayText: "articulo"
      },
      seriesGroupsTop10: [
        {
          type: "column",
          useGradient: false,
          orientation: "horizontal",
          columnsGapPercent: 50,
          toolTipFormatSettings: { thousandsSeparator: "." },
          series: [{ dataField: "Total", displayText: "Total" }]
        }
      ],
      // /Barras horizontales
      totalStock: 0,
      toparticulo: {
        nombre: "",
        total: 0
      },
      topfamilia: {
        nombre: "",
        total: 0
      },
      topsubfamilia: {
        nombre: "",
        total: 0
      }
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.getAlmacenIdCookie();
    numeral.locale("es");
  },
  mounted() {
    this.getAllAlmacen();
  },
  methods: {
    getAlmacenIdCookie() {
      if (this.$cookies.get("almacenidgrafico") !== null) {
        this.almacenid = this.$cookies.get("almacenidgrafico");
      }
    },
    almacenChange() {
      this.$cookies.set("almacenidgrafico", Number(this.almacenid));
      this.getAllStockPorFamiliaByAlmacenId();
      this.getAllStockPorSubfamiliaByAlmacenId();
      this.getTop10StockPorArticuloByAlmacenId();
    },
    getAllAlmacen() {
      biApiService
        .getAllAlmacen()
        .then(data => {
          this.almacenes = data;
          // Si no está almacenado en cookie el almacenid, cogemos el primer registro
          if (this.almacenid === undefined || this.almacenid === null) {
            if (this.almacenes.length > 0) {
              this.almacenid = Object.keys(this.almacenes[0])[0];
            }
          }
          this.getAllStockPorFamiliaByAlmacenId();
          this.getAllStockPorSubfamiliaByAlmacenId();
          this.getTop10StockPorArticuloByAlmacenId();
          util.mostrarEnConsola(
            " GraficoAlmacen - getAllAlmacen",
            data.length,
            "OK"
          );
        })
        .catch(error => {
          util.mostrarEnConsola(
            " GraficoAlmacen - getAllAlmacen",
            error,
            "ERROR"
          );
        });
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getAllStockPorFamiliaByAlmacenId() {
      // Recuperamos el id del almacen selccionado, o todos los almacenes
      this.$refs.jqxLoaderd1.open();
      let almacenidParam = [];
      // this.dataD1 = [];
      if (this.almacenid != 0) {
        almacenidParam.push(this.almacenid);
      } else {
        for (let i = 0; i < this.almacenes.length; i++) {
          almacenidParam.push(Number(Object.keys(this.almacenes[i])));
        }
      }
      biApiService
        .getAllStockPorFamiliaByAlmacenId(almacenidParam)
        .then(data => {
          if (data.length > 0) {
            if (this.dataD1.length > 0) {
              // Vaciamos los datos anteriores
              this.totalStock = 0;
              let tam = this.dataD1.length;
              for (let j = 0; j < tam; j++) {
                this.dataD1.splice(0, 1);
              }
            }
            for (let i = 0; i < data.length; i++) {
              const element = data[i];
              // Guardamos el primero, que es el de mayor valor
              if (i === 0) {
                this.topfamilia.nombre = String(Object.keys(element));
                this.topfamilia.total = numeral(
                  Number(Object.values(element))
                ).format("0,0");
              }
              this.dataD1.push({
                text: String(Object.keys(element)),
                value: Number(Object.values(element))
              });
              this.totalStock += Number(Object.values(element));
            }
            this.totalStock = numeral(this.totalStock).format("0,0");

            util.mostrarEnConsola(
              "GraficoAlmacen - getAllStockPorFamiliaByAlmacenId",
              data.length,
              "OK"
            );
            this.$refs.donut1.update();
          }
          this.$refs.jqxLoaderd1.close();
        })
        .catch(error => {
          util.mostrarEnConsola(
            " GraficoAlmacen - getAllStockPorFamiliaByAlmacenId",
            error,
            "ERROR"
          );
          this.$refs.jqxLoaderd1.close();
        });
    },
    getAllStockPorSubfamiliaByAlmacenId() {
      // Recuperamos el id del almacen selccionado, o todos los almacenes
      this.$refs.jqxLoaderd2.open();
      let almacenidParam = [];
      // this.dataD1 = [];
      if (this.almacenid != 0) {
        almacenidParam.push(this.almacenid);
      } else {
        for (let i = 0; i < this.almacenes.length; i++) {
          almacenidParam.push(Number(Object.keys(this.almacenes[i])));
        }
      }
      biApiService
        .getAllStockPorSubfamiliaByAlmacenId(almacenidParam)
        .then(data => {
          if (data.length > 0) {
            if (this.dataD2.length > 0) {
              // Vaciamos los datos anteriores
              let tam = this.dataD2.length;
              for (let j = 0; j < tam; j++) {
                this.dataD2.splice(0, 1);
              }
            }
            for (let i = 0; i < data.length; i++) {
              const element = data[i];
              // Guardamos el primero, que es el de mayor valor
              if (i === 0) {
                this.topsubfamilia.nombre = String(Object.keys(element));
                this.topsubfamilia.total = numeral(
                  Number(Object.values(element))
                ).format("0,0");
              }
              this.dataD2.push({
                text: String(Object.keys(element)),
                value: Number(Object.values(element))
              });
            }

            util.mostrarEnConsola(
              "GraficoAlmacen - getAllStockPorSubfamiliaByAlmacenId",
              data.length,
              "OK"
            );
            this.$refs.donut2.update();
          }
          this.$refs.jqxLoaderd2.close();
        })
        .catch(error => {
          util.mostrarEnConsola(
            " GraficoAlmacen - getAllStockPorSubfamiliaByAlmacenId",
            error,
            "ERROR"
          );
          this.$refs.jqxLoaderd2.close();
        });
    },
    getTop10StockPorArticuloByAlmacenId() {
      // Recuperamos el id del almacen selccionado, o todos los almacenes
      this.$refs.jqxLoadertop10.open();
      let almacenidParam = [];
      // this.dataD1 = [];
      if (this.almacenid != 0) {
        almacenidParam.push(this.almacenid);
      } else {
        for (let i = 0; i < this.almacenes.length; i++) {
          almacenidParam.push(Number(Object.keys(this.almacenes[i])));
        }
      }
      biApiService
        .getTop10StockPorArticuloByAlmacenId(almacenidParam)
        .then(data => {
          if (data.length > 0) {
            if (this.dataTop10.length > 0) {
              // Vaciamos los datos anteriores
              let tam = this.dataTop10.length;
              for (let j = 0; j < tam; j++) {
                this.dataTop10.splice(0, 1);
              }
            }
            for (let i = 0; i < data.length; i++) {
              const element = data[i];
              // Guardamos el primero, que es el de mayor valor
              if (i === 0) {
                this.toparticulo.nombre = String(Object.keys(element));
                this.toparticulo.total = numeral(
                  Number(Object.values(element))
                ).format("0,0");
              }
              this.dataTop10.push({
                articulo: String(Object.keys(element)),
                Total: Number(Object.values(element))
              });
            }
            this.$refs.barrastop10.update();
            util.mostrarEnConsola(
              "GraficoAlmacen - getTop10StockPorArticuloByAlmacenId",
              data.length,
              "OK"
            );
            this.$refs.jqxLoadertop10.close();
          }
        })
        .catch(error => {
          util.mostrarEnConsola(
            " GraficoAlmacen - getTop10StockPorArticuloByAlmacenId",
            error,
            "ERROR"
          );
          this.$refs.jqxLoadertop10.close();
        });
    }
  }
};
</script>

